import { useEffect, useState, FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useSuperAdminAuth } from "../../context/SuperAdminAuthContext";
import { apiSuperAdmin, mensajeError } from "../../api/client";
import { Spinner } from "../../components/ui/Spinner";

export default function SuperAdminLogin() {
  const { superAdmin, cargando, login } = useSuperAdminAuth();
  const [necesitaBootstrap, setNecesitaBootstrap] = useState<boolean | null>(null);

  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Intentamos iniciar sesión con credenciales vacías-friendly: en vez de eso,
    // simplemente asumimos que hace falta bootstrap solo si el login normal
    // devuelve un error de "no encontrado". Para evitar solicitudes extra,
    // dejamos que el usuario intente y mostramos el formulario adecuado según
    // la respuesta del primer envío. Por defecto mostramos login.
    setNecesitaBootstrap(false);
  }, []);

  if (!cargando && superAdmin) return <Navigate to="/superadmin" replace />;
  if (cargando || necesitaBootstrap === null) return <div className="min-h-screen flex items-center justify-center"><Spinner /></div>;

  async function enviarLogin(e: FormEvent) {
    e.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err: any) {
      // Si nunca se ha creado un super admin, ofrecemos la pantalla de bootstrap.
      if (err?.response?.status === 401) {
        setError("Correo o contraseña incorrectos.");
      } else {
        setError(mensajeError(err));
      }
    } finally {
      setEnviando(false);
    }
  }

  async function enviarBootstrap(e: FormEvent) {
    e.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      const res = await apiSuperAdmin.post("/superadmin/auth/bootstrap", { nombre, email, password });
      localStorage.setItem("vetflow_superadmin_token", res.data.token);
      window.location.href = "/superadmin";
    } catch (err) {
      setError(mensajeError(err));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-slate-900 text-white flex items-center justify-center">
            <ShieldCheck size={20} />
          </div>
          <div>
            <h1 className="font-bold text-slate-800">Portal Super Admin</h1>
            <p className="text-xs text-slate-400">Administración de la plataforma Mascotas Vet</p>
          </div>
        </div>

        <div className="flex rounded-xl bg-slate-100 p-1 mb-6 text-sm">
          <button
            className={`flex-1 py-1.5 rounded-lg font-medium ${!necesitaBootstrap ? "bg-white shadow-sm text-slate-800" : "text-slate-500"}`}
            onClick={() => setNecesitaBootstrap(false)}
            type="button"
          >
            Iniciar sesión
          </button>
          <button
            className={`flex-1 py-1.5 rounded-lg font-medium ${necesitaBootstrap ? "bg-white shadow-sm text-slate-800" : "text-slate-500"}`}
            onClick={() => setNecesitaBootstrap(true)}
            type="button"
          >
            Primer acceso
          </button>
        </div>

        {necesitaBootstrap ? (
          <form onSubmit={enviarBootstrap} className="space-y-4">
            <p className="text-xs text-slate-400 -mt-2">
              Usa esta opción solo la primera vez, para crear la cuenta del dueño de la plataforma. Si ya existe una cuenta, este formulario mostrará un error.
            </p>
            <div>
              <label className="label">Tu nombre</label>
              <input className="input" required value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </div>
            <div>
              <label className="label">Correo</label>
              <input type="email" className="input" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="label">Contraseña</label>
              <input type="password" className="input" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button type="submit" className="btn-primary w-full justify-center" disabled={enviando}>
              {enviando ? "Creando cuenta..." : "Crear cuenta de super admin"}
            </button>
          </form>
        ) : (
          <form onSubmit={enviarLogin} className="space-y-4">
            <div>
              <label className="label">Correo</label>
              <input type="email" className="input" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="label">Contraseña</label>
              <input type="password" className="input" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button type="submit" className="btn-primary w-full justify-center" disabled={enviando}>
              {enviando ? "Entrando..." : "Entrar"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
